import { useState, useMemo } from 'react'
import { useApplicationSettings } from 'hooks/usePageConfig'
import generateAuthorsInsightStrategy from 'utils/insightModal/strategy/searchFilterComposing/authorsInsightStrategy'
import generateIncludedAuthorsStrategy from 'utils/insightModal/strategy/widgetSettingComposing/includedAuthorsStrategy'
import { InsightContentSettingType } from 'components/insightContent/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import {
  convertToInsightContentSetting,
  addSelectionFilterToWidgetSetting
} from './share/InsightModal/utils'
import { AuthorsWidgetsType } from './types'

const useSelectedInsights = (
  isModalOpen: boolean,
  widgetSetting: AuthorsWidgetsType,
  setIsModalOpen: (isOpen: boolean) => void
) => {
  const applicationSettings = useApplicationSettings()
  const [selectedInsights, setSelectedInsights] = useState<InsightData[]>([])

  const detailSetting = useMemo<InsightContentSettingType | undefined>(() => {
    if (isModalOpen && selectedInsights.length > 0) {
      const searchFilterComposingStrategy = generateAuthorsInsightStrategy()
      return convertToInsightContentSetting(widgetSetting, searchFilterComposingStrategy, {
        insights: selectedInsights
      })
    }
    return undefined
  }, [isModalOpen, widgetSetting, selectedInsights])

  const widgetSettingWithSelection = useMemo<any>(() => {
    if (isModalOpen && selectedInsights.length > 0) {
      const widgetSettingComposingStrategy = generateIncludedAuthorsStrategy(applicationSettings)
      return addSelectionFilterToWidgetSetting(widgetSetting, widgetSettingComposingStrategy, {
        insights: selectedInsights
      })
    }
    return undefined
  }, [isModalOpen, widgetSetting, applicationSettings, selectedInsights])

  const handleRowClick = (targetRow: InsightData) => {
    setSelectedInsights([targetRow])
    setIsModalOpen(true)
  }

  return { selectedInsights, detailSetting, handleRowClick, widgetSettingWithSelection }
}

export default useSelectedInsights
